import React from 'react'

export const Grid = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`grid ${className}`} {...props}></div>
)
